/* eslint-disable */

//
// Adapted from https://raw.githubusercontent.com/alexreardon/memoize-one/master/src/index.js
//  

export type EqualityCallback = (newArgs: any[], lastArgs: any[]) => boolean;

const shallowEqual = (newValue: any, oldValue: any) => newValue === oldValue;

const simpleIsEqual: EqualityCallback = (newArgs: any[], lastArgs: any[]) => (
    newArgs.length === lastArgs.length &&
    newArgs.every((na: any, i: number) => shallowEqual(na, lastArgs[i]))
);

export function memoizeOne<T extends Function>(resultFn: T, isEqual: EqualityCallback = simpleIsEqual): T {

    let lastThis: any;
    let lastArgs: Array<any> = [];
    let lastResult: any;
    let calledOnce: boolean = false;

    // breaking cache when context (this) or arguments change
    const result = function (this: any, ...newArgs: any[]) {

        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }

        // Throwing during an assignment aborts the assignment: https://codepen.io/alexreardon/pen/RYKoaz
        // Doing the lastResult assignment first so that if it throws
        // nothing will be overwritten
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    };

    return result as any;
}